// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 21:48:05

export default {
  "id": "dragon-island-idle-3d",
  "slug": "dragon-island-idle-3d",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/189d36988c944e4aae10cb0564e68be6-512x512.jpg",
  "gameUrl": "https://html5.gamedistribution.com/189d36988c944e4aae10cb0564e68be6/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Dragon Island Idle 3d",
      "description": "Welcome to Dragon Island Idle 3D, a casual idle 3D world. Raise your dragons and build a wonderful island empire. Unlock all facilities to get income. For example, unlock a new pasture to raise more dinos. Unlock synths for the new area. Unlock the incubator to get dinos.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Casual"
      ],
      "tags": [
        "dragon",
        "idle",
        "island",
        "3d"
      ]
    },
    "zh-CN": {
      "title": "龙岛休闲3D",
      "description": "欢迎来到《龙岛悠闲3D》，一款休闲型3D世界游戏。培育你的龙，建立一个美好的岛屿帝国。解锁所有设施以获得收入。例如，解锁新的牧场来饲养更多恐龙。解锁新区域所需的合成器。解锁孵化器来获得恐龙。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "休闲"
      ],
      "tags": [
        "龙",
        "休闲",
        "岛屿",
        "3D"
      ]
    },
    "zh-TW": {
      "title": "龍島閒置3D",
      "description": "歡迎來到龍島休閒3D，一款輕鬆休閒3D世界。飼養你的龍，建立一個美麗的島嶼帝國。解鎖所有設施以獲得收入。例如，解鎖新的牧場來飼養更多恐龍。解鎖新區域的合成器。解鎖孵化器以獲得恐龍。",
      "instructions": "滑鼠點擊或觸控玩遊戲",
      "genres": [
        "隨意"
      ],
      "tags": [
        "龍",
        "靜態",
        "島嶼",
        "3D"
      ]
    },
    "zh-HK": {
      "title": "龍島休閒3D",
      "description": "歡迎來到龍島休閒3D，一個休閒3D世界。飼養你的龍並建立一個美麗的島嶼帝國。解鎖所有設施以獲得收入。例如，解鎖新的牧場來飼養更多恐龍。解鎖新地區的合成器。解鎖孵化器來獲得恐龍。",
      "instructions": "滑鼠點擊或觸控遊玩",
      "genres": [
        "隨意"
      ],
      "tags": [
        "龍",
        "閒置",
        "島嶼",
        "3D"
      ]
    },
    "ja": {
      "title": "ドラゴンアイランドアイドル3D",
      "description": "Dragon Island Idle 3Dへようこそ、カジュアル idle 3Dの世界です。ドラゴンを育て、素晴らしい島の帝国を築きましょう。すべての施設を解除して収益を得ましょう。例えば、新しい牧場を解除して更多の恐竜を育てます。新しいエリアのシンセサイザーを解除します。孵化器を解除して恐竜を得ます。",
      "instructions": "マウスクリックまたはタップしてゲームを始めます",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "ドラゴン",
        "アイドル",
        "島",
        "3D"
      ]
    },
    "ko": {
      "title": "드래곤 아일랜드 아이들 3D",
      "description": "드래곤 아일랜드 아이들 3D에 오신 것을 환영합니다, 캐주얼 아이들 3D 월드입니다. 드래곤을 키우고 아름다운 섬 제국을 건설하세요. 모든 시설을 해금하여 수익을 얻으세요. 예를 들어, 새로운 목장을 해금하여 더 많은 디노를 키우세요. 새로운 지역의 심합체를 해금하세요.孵化기를 해금하여 디노를 얻으세요.",
      "instructions": "마우스 클릭이나 탭하여 게임을 시작하세요",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "드래곤",
        "대기",
        "섬",
        "3D"
      ]
    },
    "fr": {
      "title": "Île Dragon Idle 3D",
      "description": "Bienvenue à Dragon Island Idle 3D, un monde de jeu casual en 3D. Élevez vos dragons et construisez une magnifique île impériale. Débloquez toutes les installations pour obtenir des revenus. Par exemple, débloquez un nouveau pâturage pour élever plus de dinosaures. Débloquez des synthétiseurs pour la nouvelle zone. Débloquez l'incubateur pour obtenir des dinosaures.",
      "instructions": "Cliquez sur la souris ou appuyez pour jouer",
      "genres": [
        "Casual"
      ],
      "tags": [
        "dragon",
        "idle",
        "île",
        "3D"
      ]
    }
  }
};
